var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "retur-modal",
      "title": "Form Request Pengembalian",
      "centered": ""
    },
    on: {
      "show": _vm.onShow,
      "hidden": _vm.resetForm
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', {
          staticClass: "d-flex justify-content-end w-100"
        }, [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "outline-secondary",
            "disabled": _vm.saving
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Batal ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.saving || !!_vm.invalidItems.length
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.submit($event);
            }
          }
        }, [_vm.saving ? _c('b-spinner', {
          staticClass: "mr-50",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Request Pengembalian ")], 1)], 1)];
      }
    }])
  }, [_c('p', {
    staticClass: "text-body mb-2"
  }, [_vm._v(" Lengkapi tanggal dan gudang tujuan sebelum mengirim request. ")]), _c('b-form-group', {
    attrs: {
      "label": "Jumlah Item",
      "label-for": "retur-jumlah-item"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "retur-jumlah-item",
      "disabled": "",
      "value": _vm.items.length
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tanggal",
      "label-for": "retur-tanggal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "retur-tanggal",
      "type": "date",
      "state": _vm.tanggalState
    },
    model: {
      value: _vm.form.tanggal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tanggal", $$v);
      },
      expression: "form.tanggal"
    }
  }), _vm.tanggalState === false ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" Tanggal wajib diisi ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Pilih Gudang",
      "label-for": "retur-gudang"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "retur-gudang",
      "options": _vm.gudangOptions,
      "state": _vm.gudangState
    },
    model: {
      value: _vm.form.id_gudang,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_gudang", $$v);
      },
      expression: "form.id_gudang"
    }
  }), _vm.gudangState === false ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" Gudang wajib dipilih ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Keterangan (opsional)",
      "label-for": "retur-keterangan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "retur-keterangan",
      "rows": "3",
      "placeholder": "Catatan pengembalian..."
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1), _vm.invalidItems.length ? _c('div', {
    staticClass: "alert alert-danger py-1 px-2 mb-0"
  }, [_vm._v(" Qty pengembalian tidak valid untuk: "), _c('ul', {
    staticClass: "mb-0 pl-2"
  }, _vm._l(_vm.invalidItems, function (item, idx) {
    return _c('li', {
      key: idx
    }, [_vm._v(" " + _vm._s(item.nama || item.id_barang) + " ")]);
  }), 0)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }